import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { useForm } from "react-hook-form";
import {
  DONATION_IMAGE_WRITE_QUERY,
  DONATION_IMAGE_LIST_QUERY,
} from "../Queries";
import { useMutation } from "react-apollo-hooks";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import { toast } from "react-toastify";

export default withRouter(({ history, match, location, isModal }) => {
  const modalRef = React.createRef();
  const [donationImageWriteMutation] = useMutation(DONATION_IMAGE_WRITE_QUERY, {
    refetchQueries: () => [
      {
        query: DONATION_IMAGE_LIST_QUERY,
        variables: { donation: match.params.id },
      },
    ],
  });
  const { register, handleSubmit, errors } = useForm();

  const [image, setImage] = useState("/assets/img/user/user-default.jpg");
  const handleDonationImage = async (e) => {
    e.preventDefault();

    const files = e.target.files;
    const file = files[0];
    var reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onloadend = () => {
      setImage(reader.result);
    };
  };
  const onClick = (e) => {
    e.preventDefault();
    document.getElementById("donationImage").click();
  };

  const onSubmit = async (data) => {
    try {
      const {
        data: { AdminDonationImageWrite },
      } = await donationImageWriteMutation({
        variables: {
          donation: match.params.id,
          file: data.file[0],
          name: data.name,
          description: data.description,
        },
      });
      if (AdminDonationImageWrite) {
        toast.success("처리 되었습니다.");
        history.push(`/donations/${match.params.id}${location.search}`);
      }
    } catch (e) {
      console.log(e);
      toast.error("에러가 발생했습니다. 다시 시도해 주세요.");
    }
  };
  //   console.log(errors);

  useEffect(() => {
    const element = modalRef.current;

    if (isModal) {
      disableBodyScroll(element);
    }

    return () => {
      enableBodyScroll(element);
    };
  });

  return (
    <>
      <Modal
        isOpen={true}
        size={"sm"}
        ref={modalRef}
        toggle={() => {
          history.push(`/donations/${match.params.id}${location.search}`);
        }}
      >
        <form className="margin-bottom-0" onSubmit={handleSubmit(onSubmit)}>
          <ModalHeader
            toggle={() => {
              history.push(`/donations/${match.params.id}${location.search}`);
            }}
          >
            등록
          </ModalHeader>
          <ModalBody className=" p-0">
            <div className="form-horizontal form-bordered">
              <div className="bg-white rounded">
                <div className="form-group row">
                  <div className="col-md-12">
                    <div className="vertical-box vertical-box-widget height-200 bg-gray-transparent-1 rounded">
                      <div className="vertical-box-column valign-middle text-center">
                        <img
                          src={image}
                          alt="이미지 업로드"
                          className="width-200"
                        />
                      </div>
                    </div>
                    <div className="m-t-10">
                      <input
                        type="file"
                        id="donationImage"
                        name="file"
                        className="hide"
                        onChange={handleDonationImage}
                        ref={register({
                          required: "이미지를 선택해주세요.",
                        })}
                      />
                      <button
                        className="btn btn-primary btn-block"
                        onClick={onClick}
                      >
                        이미지 업로드
                      </button>
                    </div>
                    {errors.file && <span>{errors.file.message}</span>}
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-form-label col-md-4">제목</label>
                  <div className="col-md-8">
                    <input
                      type="text"
                      name="name"
                      className="form-control"
                      ref={register({
                        required: "제목을 입력해주세요.",
                      })}
                    />
                    {errors.name && <span>{errors.name.message}</span>}
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-form-label col-md-4">설명</label>
                  <div className="col-md-8">
                    <textarea
                      name="description"
                      className="form-control"
                      ref={register()}
                    ></textarea>
                    {errors.description && (
                      <span>{errors.description.message}</span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <button type="submit" className="btn btn-white text-blue">
              확인
            </button>
          </ModalFooter>
        </form>
      </Modal>
    </>
  );
});
